// tab-load.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabLoadService {
  private loadTabSource = new Subject<string>();
  loadTab$ = this.loadTabSource.asObservable();

  triggerTabLoad(tabId: string) {
    this.loadTabSource.next(tabId);
  }
}